import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "content-blocking"
}, [
  /*#__PURE__*/_createElementVNode("a", { href: "#content-blocking" }),
  /*#__PURE__*/_createTextVNode(" Content Blocking ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createElementVNode("code", null, ".overlay-block"),
  /*#__PURE__*/_createTextVNode(" class for blocking an element content. ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "rounded border p-10" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "card shadow" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
            /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Content Blocking")
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "overlay overlay-block rounded" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "overlay-wrapper p-5" }, " Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to. "),
              /*#__PURE__*/_createElementVNode("div", { class: "overlay-layer rounded bg-dark bg-opacity-5" }, [
                /*#__PURE__*/_createElementVNode("div", {
                  class: "spinner-border text-primary",
                  role: "status"
                }, [
                  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_5 = { class: "py-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(`
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">Content Blocking</h3>
          </div>
          <div class="card-body">
            <div class="overlay overlay-block rounded">
              <div class="overlay-wrapper p-5">
                Lorem Ipsum is simply dummy text...
              </div>
              <div class="overlay-layer rounded bg-dark bg-opacity-5">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        `), 1)
        ]),
        _: 1
      })
    ])
  ]))
}